import axios from 'axios';

const BACKEND_API_URL = 'https://debate-bot-backend.onrender.com/api';

export const fetchArguments = async (topic) => {
    try {
        console.log('Fetching arguments for topic:', topic);
        
        const response = await axios.post(`${BACKEND_API_URL}/debate`, { topic });
        
        console.log('Response received:', response.data);
        
        return {
            for: response.data.argumentsFor || [],
            against: response.data.argumentsAgainst || []
        };
    } catch (error) {
        console.error('Error fetching arguments:', error);
        
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        
        throw error;
    }
};

export const generateRebuttal = async (selectedArgument) => {
    try {
        const response = await axios.post(`${BACKEND_API_URL}/rebuttal`, { 
            argument: selectedArgument 
        });
        return response.data.rebuttal;
    } catch (error) {
        console.error('Error generating rebuttal:', error);
        throw error;
    }
};